define('Office_retail.ei1.Main.View', [
    'SCView',
    'officeretail.tpl',
    'Office_retail.ei1.Main.Model'
], function (
    SCViewComponent,
    officeretail_tpl,
    OfficeRetailModel
) {
    'use strict';

    var SCView = SCViewComponent.SCView;
    var self = null;

    var ITEMS_PER_CATEGORY = 3;
    var MORE_ITEMS_COUNT = 3;
    var MAX_CATEGORIES = 4;

    /**
     * Fisher-Yates shuffle — returns a NEW shuffled array (original untouched)
     */
    function shuffle(arr) {
        var a = arr.slice();
        for (var i = a.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = a[i];
            a[i] = a[j];
            a[j] = temp;
        }
        return a;
    }

    function fetchItemImages(itemIds) {
        if (!itemIds || itemIds.length === 0) return jQuery.when({});

        var url = '/api/items?fieldset=details&limit=100';

        return jQuery.get(url).then(function (res) {
            var imageMap = {};
            var items = res.items || [];

            items.forEach(function (item) {
                var id = String(item.internalid);
                if (itemIds.indexOf(id) === -1) return;

                var imageUrl = '';
                if (
                    item.itemimages_detail &&
                    item.itemimages_detail.urls &&
                    item.itemimages_detail.urls.length > 0 &&
                    item.itemimages_detail.urls[0].url
                ) {
                    imageUrl = item.itemimages_detail.urls[0].url;
                }

                imageMap[id] = {
                    imageUrl: imageUrl,
                    urlComponent: item.urlcomponent || ''
                };
            });

            return imageMap;
        });
    }

    /**
     * Builds the final categories array ONCE per page load.
     * - Each subcategory tab: 3 random items (re-randomized on every page refresh)
     * - "More" tab: 1 random item per subcategory (subcategories visited in random
     *   order), up to 3 items. Prefers items NOT already shown in the tabs.
     */
    function prepareCategories(data) {
        var sortedSubCategories = data.subCategories.slice().sort(function (a, b) {
            return (Number(a.subcategorySequence) || 0) - (Number(b.subcategorySequence) || 0);
        }).slice(0, MAX_CATEGORIES);

        var usedIds = {};

        // ── Subcategory tabs: 3 random items each ──
        var categories = sortedSubCategories.map(function (subCat) {
            var randomItems = shuffle(subCat.items || []).slice(0, ITEMS_PER_CATEGORY);

            return {
                id: subCat.id,
                name: subCat.name,
                items: randomItems.map(function (item) {
                    usedIds[item.id] = true;
                    return {
                        id: item.id,
                        name: item.name,
                        price: item.price,
                        imageUrl: '',
                        categoryName: subCat.name
                    };
                })
            };
        });

        // ── "More" tab: 1 random item from each subcategory ──
        // Uses ALL subcategories (not just the 3 displayed) for a wider pool
        var moreItems = [];
        var shuffledSubCats = shuffle(data.subCategories || []);

        shuffledSubCats.forEach(function (subCat) {
            if (moreItems.length >= MORE_ITEMS_COUNT) return;

            var allItems = subCat.items || [];
            if (allItems.length === 0) return;

            // Prefer items not already displayed in a tab, fall back to any item
            var pool = allItems.filter(function (item) {
                return !usedIds[item.id];
            });
            if (pool.length === 0) pool = allItems;

            var pick = pool[Math.floor(Math.random() * pool.length)];

            moreItems.push({
                id: pick.id,
                name: pick.name,
                price: pick.price,
                imageUrl: '',
                categoryName: subCat.name
            });
            usedIds[pick.id] = true;
        });

        // If fewer subcategories than MORE_ITEMS_COUNT, top up with random leftovers
        if (moreItems.length < MORE_ITEMS_COUNT) {
            var leftovers = [];
            (data.subCategories || []).forEach(function (subCat) {
                (subCat.items || []).forEach(function (item) {
                    if (!usedIds[item.id]) {
                        leftovers.push({ item: item, categoryName: subCat.name });
                    }
                });
            });

            shuffle(leftovers).forEach(function (entry) {
                if (moreItems.length >= MORE_ITEMS_COUNT) return;
                moreItems.push({
                    id: entry.item.id,
                    name: entry.item.name,
                    price: entry.item.price,
                    imageUrl: '',
                    categoryName: entry.categoryName
                });
                usedIds[entry.item.id] = true;
            });
        }

        if (moreItems.length > 0) {
            categories.push({
                id: 'more',
                name: 'More',
                items: moreItems
            });
        }

        return categories;
    }

    function OfficeretailMainView(options) {
        SCView.call(this);
        self = this;
        self.options = options || {};
        self.template = officeretail_tpl;
        self.model = new OfficeRetailModel();
        self.preparedCategories = [];

        self.model.fetch().done(function () {
            var response = self.model.toJSON();

            if (!response || !response.success || !response.data) {
                console.error('Backend error:', response && response.message);
                self.render();
                return;
            }

            // Selection happens ONCE here — stays stable across re-renders,
            // only re-randomizes on a real page reload
            self.preparedCategories = prepareCategories(response.data);

            // Only fetch images for the items we actually display
            var displayedIds = [];
            self.preparedCategories.forEach(function (cat) {
                cat.items.forEach(function (item) {
                    if (displayedIds.indexOf(item.id) === -1) displayedIds.push(item.id);
                });
            });

            fetchItemImages(displayedIds).done(function (imageMap) {
                self.preparedCategories.forEach(function (cat) {
                    cat.items.forEach(function (item) {
                        var info = imageMap[item.id] || {};
                        item.imageUrl = info.imageUrl || '';
                        item.itemUrl = info.urlComponent ? ('/' + info.urlComponent) : '';
                    });
                });
                self.render();
            }).fail(function () {
                self.render();
            });
        });
    }

    OfficeretailMainView.prototype = Object.create(SCView.prototype);
    OfficeretailMainView.prototype.constructor = OfficeretailMainView;

    OfficeretailMainView.prototype.getContext = function () {
        var categories = self.preparedCategories || [];

        return {
            hasData: categories.length > 0,
            categories: categories,
            firstCategoryId: categories.length > 0 ? categories[0].id : ''
        };
    };

    return OfficeretailMainView;
});
